import React from 'react';
import * as Styles from '../../../../SharedModules/StyleConstant/StyleConstant';

import MaxLengthNumericEditor from '../../../../SharedModules/CustomAgGridEditor/inputComponent';
import {
  comparatorQtr,
  textMatcherWith2Decimal,
} from '../../../../SharedModules/utilities/utilities';
import { handleCommaSeparatedAmount } from '../../../../SharedModules/CommonUtilities/commonUtilities';

const ragRenderer = (params) => {
  const { value } = params;
  const { isTextColorRed } = params.colDef;
  const { printPrefixValue } = params.colDef;
  const { printPostfixValue } = params.colDef;
  if (value === '') return '';
  if (value < 0) {
    return (
      <span
        style={{
          color: isTextColorRed ? '#a81f00' : '',
          fontWeight: params?.data?.isBottomRow ? 600 : 'normal',
        }}
      >
        {`( ${handleCommaSeparatedAmount(
          value?.toString()?.replace('-', '').trim()
        )} )`}
      </span>
    );
  }
  if (value > -1) {
    return <span>{handleCommaSeparatedAmount(value)}</span>;
  }
  return params.value || '';
};

const fourDecimalRenderer = (params, a) => {
  const { value } = params;
  const { isTextColorRed } = params.colDef;
  const { printPrefixValue } = params.colDef;
  const { printPostfixValue } = params.colDef;
  if (value === '') return '';
  if (value < 0) {
    return (
      <span
        style={{
          color: isTextColorRed ? '#a81f00' : '',
        }}
      >
        {`(${printPrefixValue ? `${printPrefixValue} ` : ''}${parseFloat(value)
          .toLocaleString('en-US', {
            minimumFractionDigits: 4,
            maximumFractionDigits: 4,
          })
          .substring(1)})` + `${printPostfixValue || ''}`}
      </span>
    );
  }
  if (value > -1) {
    return (
      <span>
        {`${
          (printPrefixValue ? `${printPrefixValue} ` : '') +
          parseFloat(value).toLocaleString('en-US', {
            minimumFractionDigits: 4,
            maximumFractionDigits: 4,
          })
        }${printPostfixValue || ''}`}
      </span>
    );
  }
  return params.value || '';
};

function amountComparator(amount1, amount2) {
  let amt1 = null;
  let amt2 = null;
  if (amount1 && amount1?.toString()?.includes('$')) {
    amt1 = parseFloat(
      amount1?.toString().split('$')[1]?.toString()?.replace(',', '').trim()
    );
  } else {
    amt1 = parseFloat(amount1?.toString()?.replace(',', '').trim());
  }
  if (amount2 && amount2?.toString()?.includes('$')) {
    amt2 = parseFloat(
      amount2?.toString().split('$')[1]?.toString()?.replace(',', '').trim()
    );
  } else {
    amt2 = parseFloat(amount2?.toString()?.replace(',', '').trim());
  }
  if (amt1 === null && amt2 === null) {
    return 0;
  }
  if (amt1 === null) {
    return -1;
  }
  if (amt2 === null) {
    return 1;
  }

  return amt1 - amt2;
}
// For the proper sorting of quarter columns

export const AllManufacturer = [
  {
    headerName: 'Manufacturer ID',
    field: 'mfgId',
    editable: false,
    sortable: true,
    suppressMenu: false,
    resizable: true,
    sort: 'asc',
    minWidth: Styles.Width_100,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Manufacturer Name',
    field: 'mfgName',
    editable: false,
    sortable: true,
    suppressMenu: false,
    resizable: true,
    minWidth: Styles.Width_100,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { borderRightColor: Styles.BorderColor },
    cellRenderer: 'TextBoxRender',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];

export const AllQuarterDrug = [
  {
    headerName: 'Actions', // field: 'mailed',
    editable: false,
    sortable: false,
    filter: false,
    wrapText: true,
    suppressMenu: false,
    resizable: true,
    minWidth: Styles.Width_85,
    cellRenderer: 'ActionCellRender',
    pdfExportOptions: {
      skipColumn: true,
    },
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { borderRightColor: Styles.BorderColor },
    // filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Quarter',
    field: 'qtr',
    editable: false,
    sortable: true,
    wrapText: true,
    suppressMenu: false,
    resizable: true,
    minWidth: Styles.Width_120,
    comparator: comparatorQtr,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'NDC',
    field: 'ndc',
    editable: false,
    sortable: true,
    suppressMenu: false,
    resizable: true,
    minWidth: Styles.Width_150,
    cellRenderer: 'TextBoxRender',
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Drug Name',
    field: 'drugName',
    editable: false,
    sortable: true,
    wrapText: true,
    suppressMenu: false,
    resizable: true,
    cellRenderer: 'TextBoxRender',
    cellClass: 'frr-ellipsis-text',
    minWidth: Styles.Width_240,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { borderRightColor: Styles.BorderColor },
    columnSpan: 3,
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: 'Disp Cd ',
    field: 'dispCd',
    editable: false,
    sortable: true,
    suppressMenu: false,
    resizable: true,
    minWidth: Styles.Width_150,
    cellEditor: MaxLengthNumericEditor,
    cellClass: 'frr-ellipsis-text',
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Orig Disp Units',
    field: 'origDispUnits',
    editable: false,
    sortable: true,
    suppressMenu: false,
    resizable: true,
    minWidth: Styles.Width_150,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    cellRenderer: fourDecimalRenderer,
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    comparator: amountComparator,
    excelAlignment: 'right',
    isTextColorRed: true,
    alignment: 'right',
  },
  {
    headerName: 'Disputed Units',
    field: 'disputedUnits',
    editable: false,
    sortable: true,
    suppressMenu: false,
    resizable: true,
    minWidth: Styles.Width_110,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    cellRenderer: fourDecimalRenderer,
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    comparator: amountComparator,
    excelAlignment: 'right',
    isTextColorRed: true,
    alignment: 'right',
  },
  {
    headerName: 'Current Invoiced',
    field: 'curr_Inv',
    editable: false,
    sortable: true,
    suppressMenu: false,
    resizable: true,
    minWidth: Styles.Width_130,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    isTextColorRed: true,
    printPrefixValue: '$',
    cellRenderer: ragRenderer,
    comparator: amountComparator,
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
      textMatcher: textMatcherWith2Decimal,
    },
  },
  {
    headerName: 'Paid Amount',
    field: 'paidAmt',
    editable: false,
    sortable: true,
    suppressMenu: false,
    resizable: true,
    minWidth: Styles.Width_125,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    isTextColorRed: true,
    printPrefixValue: '$',
    cellRenderer: ragRenderer,
    comparator: amountComparator,
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
      textMatcher: textMatcherWith2Decimal,
    },
  },
  {
    headerName: 'Balance Due',
    field: 'bal_Due',
    editable: false,
    sortable: true,
    suppressMenu: false,
    resizable: true,
    minWidth: Styles.Width_120,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    isTextColorRed: true,
    printPrefixValue: '$',
    cellRenderer: ragRenderer,
    comparator: amountComparator,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
      textMatcher: textMatcherWith2Decimal,
    },
  },
];
export const IncludeActivityTableHead = [
  {
    headerName: 'Activity',
    field: 'activity',
    editable: false,
    sortable: true,
    suppressMenu: false,
    resizable: true,
    wrapText: true,
    cellRenderer: 'TextBoxRender',
    minWidth: Styles.Width_200,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Qtr Occur',
    field: 'daInvQtr',
    editable: false,
    sortable: true,
    suppressMenu: false,
    resizable: true,
    minWidth: Styles.Width_120,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Amount',
    field: 'daChangeAmt',
    editable: false,
    sortable: true,
    suppressMenu: false,
    resizable: true,
    minWidth: Styles.Width_125,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    isTextColorRed: true,
    printPrefixValue: '$',
    cellRenderer: ragRenderer,
    comparator: amountComparator,
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
      textMatcher: textMatcherWith2Decimal,
    },
  },
  {
    headerName: 'Units',
    field: 'daUnits',
    editable: false,
    sortable: true,
    suppressMenu: false,
    resizable: true,
    minWidth: Styles.Width_80,
    cellRenderer: fourDecimalRenderer,
    comparator: amountComparator,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    excelAlignment: 'right',
    alignment: 'right',
    isTextColorRed: true,
  },
  {
    headerName: 'Units Changed',
    field: 'daChangeUnits',
    editable: false,
    sortable: true,
    suppressMenu: false,
    resizable: true,
    minWidth: Styles.Width_130,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    isTextColorRed: true,
    excelAlignment: 'right',
    cellRenderer: ragRenderer,
    comparator: amountComparator,
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    alignment: 'right',
  },
  {
    headerName: 'Pct Changed',
    // field: 'disputedUnits',
    editable: false,
    sortable: true,
    suppressMenu: false,
    resizable: true,
    minWidth: Styles.Width_130,
    cellEditor: MaxLengthNumericEditor,
    isTextColorRed: true,

    cellRenderer: ragRenderer,
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'URA',
    field: 'daUra',
    editable: false,
    sortable: true,
    suppressMenu: false,
    resizable: true,
    minWidth: Styles.Width_100,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    isTextColorRed: true,
    comparator: amountComparator,
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
      textMatcher: textMatcherWith2Decimal,
    },
  },
];
